import React, { useState } from "react"
import Select, { components } from "react-select"

import PropTypes from "prop-types"

import dropdownIcon from "../assets/images/dropdown.png"

const Dropdown = ({ options, placeholder, name }) => {
  const [selectedOption, setSelectedOption] = useState(null)
  const [isMenuOpen, setMenuStatus] = useState(false)

  function selectChange(selected) {
    setSelectedOption(selected)
  }

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <img
          className={isMenuOpen ? "rotate-180deg" : ""}
          src={dropdownIcon}
          alt="down arrow"
        />
      </components.DropdownIndicator>
    )
  }

  const customStyles = {
    menu: (base) => ({
      ...base,
      marginTop: 0,
    }),
    menuList: (base) => ({
      ...base,
      backgroundColor: "#ccc7c4",
      color: "#303030",
    }),
    option: (base) => {
      return {
        ...base,
        "&:hover": {
          backgroundColor: "#303030",
          color: "#ffffff",
          cursor: "pointer",
        },
        textAlign: "left",
      }
    },
  }

  return (
    <div className="dropdown">
      <Select
        name={name}
        placeholder={placeholder}
        defaultValue={selectedOption}
        onChange={selectChange}
        options={options}
        theme={(theme) => ({
          ...theme,
          borderRadius: 4,
          colors: {
            ...theme.colors,
            primary: "#303030",
            primary25: "#ccc7c4",
          },
        })}
        styles={customStyles}
        components={{ DropdownIndicator }}
        onMenuClose={() => setMenuStatus(false)}
        onMenuOpen={() => setMenuStatus(true)}
      />
    </div>
  )
}

Dropdown.propTypes = {
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
}

export default Dropdown
